<template>
  <v-app :style="'height:100%;background-image:url(' + bg + ');background-size:cover;'">
      <div style="height:50%;position: relative;">
          <v-img :src="logo" width="50%" style="margin: auto;position:absolute; bottom:0;left:25%;" class="mb-6" />
      </div>
      <div style="height:10%;">
        <div class="text-h5">{{ name }}</div>
        <div class="text-h5">{{ $t('Station_Welcome') }}</div>
      </div>
      <div style="height:40%;" class="pt-14">
          <!--<div  v-if="welcomestatus.is_showlist"><v-btn  color="#00E4FF" class="pa-5 text-h5 ma-2">
            {{ $t('welcome_list') }}
          </v-btn></div>-->
          <div><v-btn  color="#00E4FF" class="pa-5 text-h5 ma-2" @click="$router.push({name:'AppointmentNew'})">
            {{ $t('welcome_reservation') }}
          </v-btn></div>
          <div  v-if="welcomestatus.is_showactivate"><v-btn  color="#00E4FF" class="pa-5 text-h5 ma-2"  @click="$router.push({name:'Activate'})">
            {{ $t('welcome_activate') }}
          </v-btn></div>
      </div>
  </v-app>
</template>

<style>
html {
    height: 100%;
}
body {
    height: 100%;
}
#app {
    height: 100%;
}
</style>

<script>

import App from '@/models/instance/App'
import axios from 'axios';
import config from '@/../config.js'
import Member from '@/models/instance/Member'

export default {
  data () {
    return {
      bg : ""
      ,logo : require('@/assets/9manat-line-logo-01.png')
      ,name : ""
      ,welcomestatus : {
        is_showlist : false,is_showactivate : false
      }
    }
  },
  mounted : function () {
    this.bg = App.getAppConfigBackgroud()
    this.logo = App.getAppConfigLogo()
    this.name = App.getAppConfigName()
    var que = this.$store.commit('addLoading')
    axios
        .post(config.api.url.line.appointment.get_welcomestatus
          ,{ app_id: App.getAppId()}
          ,{ headers: Member.getTokenHeader()})
        .then(response => {
            this.welcomestatus = response.data
            this.$store.commit('finishLoading',que)
        })
  },
  methods : {

  },
}
</script>